//const baseURL = 'http://localhost:8873';
//const baseURL = 'http://39.108.113.20:8873';
const baseURL = '/api/pm';

const projects=`${baseURL}/projects`
const filter=`${baseURL}/projects/filter`

const milestone=`${baseURL}/milestones`

const task=`${baseURL}/tasks`
const taskByProject=`${baseURL}/tasks/project`
const taskByMilestone=`${baseURL}/tasks/milestone`

const issue=`${baseURL}/issues`

const workLog=`${baseURL}/worklog`
const workLogTask=`${workLog}/task`

const projectSystem = `${baseURL}/projects`
const getProjectTreeById=`${projectSystem}/getProjectTreeById`
const updateSystem=`${projectSystem}/updateSystem`

const projectType = `${baseURL}/projectType`

const folderTree =`${baseURL}/projectFile`


export default{
    projects,
    filter,

    milestone,
    
    task,
    taskByProject,
    taskByMilestone,

    issue,

    workLog,
    workLogTask,

    getProjectTreeById,
    updateSystem,
    projectType,
    folderTree
}
